// Function to enter full screen
export const goFullScreen = (element) => {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullscreen) { // Safari
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) { // IE11
    element.msRequestFullscreen();
  }
};

export const exitFullScreen = (element) => {
    if (element.exitFullscreen) {
        element.exitFullscreen();
      } else if (element.webkitExitFullscreen) { /* Safari */
        element.webkitExitFullscreen();
      } else if (element.msExitFullscreen) { /* IE/Edge */
        element.msExitFullscreen();
      }
};

